import { toCanvas } from 'qrcode';

frappe.ui.form.ControlQrcode = class ControlQrcode extends frappe.ui.form.ControlData {
    make_wrapper() {
        // Create the elements for QR code area
        super.make_wrapper();
        console.log("qrcode");

        // Default SVG canvas for the QR code
        this.default_svg = "<canvas height=128 width=128></canvas>";
        let $input_wrapper = this.$wrapper.find(".control-input-wrapper");
        this.qrcode_area = $(`<div class="qrcode-wrapper">${this.default_svg}</div>`);
        this.qrcode_area.appendTo($input_wrapper);
    }

    parse(value) {
        // Parse raw value and return it directly without generating the QR code
        return value || "";
    }

    set_formatted_input(value) {
        // Set values to display and update the QR code
        let qrcode_value = value;

        this.set_empty_description();

        if (qrcode_value && this.doc) {
            this.get_qrcode_html(qrcode_value);
            this.doc[this.df.fieldname] = qrcode_value;
        }

        // Set the formatted value in the input field
        this.$input.val(qrcode_value || value);
    }

    get_qrcode_html(value) {
        if (value) {
            // Get canvas element and generate the QR code
            const canvas = this.qrcode_area.find("canvas")[0];
            try {
                toCanvas(canvas, value, this.get_options(value), (error) => {
                    if (error) console.error(error);
                    console.log('QR code generated!');
                });
                return true;  // Return true if the QR code is successfully generated
            } catch (e) {
                this.set_description(`Invalid QR Code: ${String(e)}`);
                return false;
            }
        }
    }

    get_options(value) {
        // Get QR code options
        let options = {
            width: 128,
            height: 128
        };

        if (frappe.utils.is_json(this.df.options)) {
            options = { ...options, ...JSON.parse(this.df.options) };

            if (options.valueField) {
                // Set companion field value if specified
                this.frm && this.frm.set_value(options.valueField, value);
            }
        }
        return options;
    }
};